export enum ClientRoutesEnum {
  HOME = '/',
  PROFILE = '/profile/:addressId',
  CREATE = '/create',
  ABOUT = '/about',
  PRIVACY = '/privacy',
  TERMS = '/terms'
}
